import { FC, ReactNode } from 'react'

import { DontDisturbBottomsheet } from '../../../dont-disturb-bottomsheet'
import { Container } from '../means-of-communication-br/styles/MeansOfCommunicationBr.styles'

interface MeansOfCommunicationListProps {
  children: ReactNode
  isDontDisturbBottomsheetVisible?: boolean
  onCloseDontDisturbBottomsheet?: () => void
}

export const MeansOfCommunicationList: FC<MeansOfCommunicationListProps> = ({
  children,
  isDontDisturbBottomsheetVisible = false,
  onCloseDontDisturbBottomsheet,
}) => (
  <Container>
    <section>{children}</section>
    {isDontDisturbBottomsheetVisible && onCloseDontDisturbBottomsheet && (
      <DontDisturbBottomsheet onClose={onCloseDontDisturbBottomsheet} />
    )}
  </Container>
)
